import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

export const appTheme = createMuiTheme({
  palette: {
    primary: { main: '#1976d2' },
  },
});